function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Layer 1",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M212.84 0H0v125.87h6l-5.13 7.87h8.87l7.87-7.87h177.62l7.87 7.87h8.9l-5.14-7.87h6zm-3 122.87H3V3h206.84z"
}), React.createElement("path", {
  d: "M8.47 9.21h196.11v107.77H8.47z"
}), React.createElement("path", {
  d: "M91.68 145.71H49.84A10.74 10.74 0 0139.12 135V33.84a10.73 10.73 0 0110.72-10.72h41.84a10.74 10.74 0 0110.73 10.72V135a10.74 10.74 0 01-10.73 10.71zM49.84 26.12a7.72 7.72 0 00-7.72 7.72V135a7.73 7.73 0 007.72 7.73h41.84a7.74 7.74 0 007.73-7.73V33.84a7.73 7.73 0 00-7.73-7.72z"
}), React.createElement("rect", {
  x: 42.12,
  y: 26.12,
  width: 57.29,
  height: 116.59,
  rx: 7.73
}), React.createElement("path", {
  d: "M95.35 33.85V135a3.67 3.67 0 01-3.67 3.67H49.84a3.67 3.67 0 01-3.67-3.67V33.85a3.67 3.67 0 013.67-3.67h6.64v2.42a3.72 3.72 0 003.72 3.72h21.12A3.72 3.72 0 0085 32.6v-2.42h6.64a3.67 3.67 0 013.71 3.67z"
}), React.createElement("rect", {
  x: 59.66,
  y: 30.16,
  width: 22.21,
  height: 2.85,
  rx: 1.42
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 212.84 145.71"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/marketing.svg";
export { SvgComponent as ReactComponent };